import { type SectionType } from '@repo/utils';

export const getFormSections = `
  query getFormSections($formTabId: ID!) {
    formSections(formTabId: $formTabId) {
      id
      name
      sequenceNumber
      formTabId
    }
  }
`;

export type FormSectionsSectionType = Pick<SectionType, 'id' | 'name' | 'sequenceNumber' | 'formTabId'>;

export interface GetFormSectionsQuery {
  formSections: FormSectionsSectionType[];
}
